<div class="flex flex-col px-4 sm:flex-row sm:space-x-8">
  <!-- Left column for section name -->
  <div class="mb-4 w-full sm:mb-0 sm:w-2/5">
    <h2 class="text-xl leading-[30px] font-normal text-primary-text">
      {{ sectionName() }}
    </h2>
  </div>

  <!-- Right column for questions -->
  <div class="w-full sm:w-3/5">
    <div class="flex w-full flex-col bg-primary-background">
      @for (item of questions(); track item; let i = $index) {
        <div class="w-full">
          <hr class="border-borderColor-secondary w-full" />
          <button
            class="flex w-full items-center justify-between py-5 focus:outline-none"
            [attr.aria-expanded]="item.isOpen"
            (click)="toggleQuestion(i)"
          >
            <div
              class="text-left text-lg leading-[27px] font-light text-primary-text"
            >
              {{ item.question }}
            </div>
            <span
              class="flex h-8 w-8 items-center justify-center text-2xl transition-transform duration-300"
              [ngClass]="{ 'rotate-45': item.isOpen }"
            >
              +
            </span>
          </button>
          <div
            class="w-full overflow-hidden transition-all duration-300 ease-in-out"
            [ngClass]="{
              'max-h-0': !item.isOpen,
              'max-h-screen pb-5': item.isOpen,
            }"
          >
            <div
              class="text-base leading-normal font-normal text-secondary-text"
            >
              {{ item.answer }}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
